<template>
  <v-parallax 
    height="200"
    :src="bg"
  ></v-parallax>
</template>

<script>
export default {
  data () {
    return {
      bg: require('@/assets/bg/elearning.png')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/parallax.vue